import { Component, OnDestroy } from '@angular/core';
import { UserControlService } from 'src/app/shared/service/userControl/user-control.service';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { AppRoutes } from "src/app/shared/lib/api-constant";
import { SubSink } from 'subsink';

@Component({
  selector: 'app-association',
  templateUrl: './app.association.component.html',
  standalone :false
})
export class AppAssociationComponent implements OnDestroy {
  private subscription = new SubSink();
  constructor(
    private userControlService: UserControlService,
    private commonService: CommonService
  ) {

    this.subscription.add(
    this.userControlService.$userFeatures.subscribe((features: any) => {
      if (features) {
        this.commonService.navigateRoute({
          route: AppRoutes.User.HOME,
          type: 'User'
        });
      }
    })
    );

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
